import { useIntl } from "react-intl";

type TrustSectionSpacesCarouselListItem = {
  id: string;
  spaceCarouselItemLabel: string;
  spaceCarouselItemImageSrc: string;
};

const useTrustSectionSpacesCarouselList =
  (): TrustSectionSpacesCarouselListItem[] => {
    const intl = useIntl();

    return [
      {
        id: "bars_lounges",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Bars & lounges",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_1",
      },
      {
        id: "backyards_pools",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Backyards & pools",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_2",
      },
      {
        id: "event_venues",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Event venues",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_3",
      },
      {
        id: "photo_studios",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Photo studios",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_4",
      },
      {
        id: "rooftops",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Rooftops",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_5",
      },
      {
        id: "meeting_spaces",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Meeting spaces",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_6",
      },
      {
        id: "homes",
        spaceCarouselItemLabel: intl.formatMessage({ defaultMessage: "Homes" }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_7",
      },
      {
        id: "cafes_restaurants",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Cafes & restaurants",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_8",
      },
      {
        id: "gardens",
        spaceCarouselItemLabel: intl.formatMessage({
          defaultMessage: "Gardens",
        }),
        spaceCarouselItemImageSrc:
          "https://img.peerspace.com/image/upload/c_fill,g_auto,w_556,h_630,f_auto,q_auto/v1780512812/host_page/space_9",
      },
    ];
  };

export { useTrustSectionSpacesCarouselList };
